var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "139px",
    height: "160px",
    viewBox: "0 0 139 160",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-2",
    transform: "translate(-100.000000, -89.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.857511,239.538149 C135.279791,239.640017 134.507676,239.780751 133.352235,239.984486 C127.465895,241.022407 121.848268,237.172121 120.663876,231.349659 L120.60922,231.061731 L100.466031,116.824031 C99.4281108,110.937692 103.278397,105.320064 109.100859,104.135672 L109.388787,104.081016 L189.158215,90.0155138 C195.141052,88.9605782 200.846294,92.9554318 201.90123,98.9382692 L204.917853,111 L192.442674,111 L190.257,102.007 L112.457,115.724 L132.252,227.992 L135.751172,227.357391 L135.857511,239.538149 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.755225,117 L227.755225,117 C230.516649,117 232.755225,119.238576 232.755225,122 L232.755225,238 C232.755225,240.761424 230.516649,243 227.755225,243 L146.755225,243 C143.993801,243 141.755225,240.761424 141.755225,238 L141.755225,122 C141.755225,119.238576 143.993801,117 146.755225,117 Z",
    id: "Rectangle",
    stroke: "currentColor",
    strokeWidth: 12
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards);
export default __webpack_public_path__ + "static/media/cards.e97f2cc8b4459ce272b0a787c1b3aff1.svg";
export { ForwardRef as ReactComponent };